import { Controller } from "stimulus"

/**
 * toggleCSS toggles CSS classes defined in a dataset on or off on the given
 * HTML element.
 * @param {HTMLElement} target HTMLElement to target.
 * @param {Boolean} on Whether to toggle on or off.
 */
const toggleCSS = (target, on) => {
  const onCSS = target.dataset.cssOn.split(" ")
  const offCSS = target.dataset.cssOff.split(" ")

  if (on) {
    target.classList.add(...onCSS)
    target.classList.remove(...offCSS)
  } else {
    target.classList.remove(...onCSS)
    target.classList.add(...offCSS)
  }
}

export default class extends Controller {
  static get targets() {
    return [
      "day",
      "time",
      "timeSelection",
      "label",
      "submit",
      "timeslot",
      "form",
      "error"
    ]
  }

  connect = () => {
    this.change()
  }

  /**
   * change handles the radio button selection events in order to update
   * the form's appearance, and to to update the timeslot selection view in
   * the sidebar.
   */
  change = () => {
    const index = this._getSelectedDay()
    this._showDeliveryTimesAtIndex(index)
    this._updateSelectedTimeslot()
  }

  /**
   * submit validates that the form is valid before submission.
   * @param {Event} ev The form submission event.
   */
  submit = (ev) => {
    // Check if a timeslot is selected.
    var isChecked = false
    this.timeSelectionTargets.forEach(el => {
      if (el.checked) {
        isChecked = true
      }
    })

    // If no timeslot is selected, don't allow allow the form to submit.
    if (!isChecked) {
      this.errorTarget.innerText = "No timeslot selected. Please select a timeslot to continue."
      this.errorTarget.classList.remove("hidden")

      ev.preventDefault()
      return false
    }
  }

  /**
   * Returns the index of the currently selected index as a string.
   * @returns The index of the selected day.
   */
  _getSelectedDay = () => {
    let index = ""

    this.dayTargets.forEach(btn => {
      if (btn.checked) {
        index = btn.id.charAt(btn.id.length - 1)
      }

      const label = btn.labels && btn.labels[0]
      toggleCSS(label, btn.checked)
    })

    return index
  }

  /**
   * Shows the delivery times for the chosen day. Hides all others.
   * @param {String} index The index of the timeslots to show.
   */
  _showDeliveryTimesAtIndex = (index) => {
    this.timeTargets.forEach(slot => {
      const i = slot.id.charAt(slot.id.length - 1)

      if (i === index) {
        slot.classList.remove("hidden")
        slot.classList.add("flex")
      } else {
        slot.classList.remove("flex")
        slot.classList.add("hidden")
      }
    })
  }

  /**
   * Updates the order summary to show the currently selected human readable
   * day and timeslot.
   */
  _updateSelectedTimeslot = () => {
    this.timeSelectionTargets.forEach(sel => {
      if (sel.checked) {
        this.errorTarget.classList.add("hidden")

        this.submitTarget.value = `Continue – ${sel.dataset.timeslotLabel}`
        this.timeslotTarget.innerText = sel.dataset.timeslotLabel
        this.labelTarget.value = sel.dataset.timeslotLabel
      }

      // Update styles on the associated label.
      const label = sel.labels && sel.labels[0]
      toggleCSS(label, sel.checked)
    })
  }
}
